//@flow
import React from 'react';
//Styles
import './OptionBox.css';
//Helpers
import { scaleConverter } from '../../common';
import ProgressiveImageLoader from '../../common/components/ProgressiveImageLoader';
import noImage from '../../common/images/noImageChicken.png';

type Props = {
  imgSrc: string,
  text: string,
  isSelected: boolean,
  optionPrice: string,
  productPrice: string,
  productUnit: string,
  optionTitle: string,
  imageUrl?: string,
  isGiftCard?: boolean,
};

const OptionBox = (props: Props) => {
  const selected = props.isSelected ? 'option-box-selected' : '';

  const productPrice = scaleConverter(props.productPrice, props.productUnit);
  const optionPrice = scaleConverter(props.optionPrice, props.productUnit);

  const priceDifference = optionPrice - productPrice;
  const formattedPriceDifference = Math.abs(priceDifference).toLocaleString(
    'pt-BR',
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  );

  if (props.optionTitle === 'Cores') {
    if (!props.imageUrl || props.imageUrl === '/images/image/missing.png') {
      return (
        <img
          src={noImage}
          alt={props.imageUrl}
          className="option-image-loader-final-img"
        />
      );
    }

    return (
      <img
        src={props.imageUrl}
        alt={props.imageUrl}
        className="option-image-loader-final-img"
      />
    );
  }

  if (props.isGiftCard) {
    return (
      <div className={`option-box-main ${selected}`}>
        <div className="option-box-text">
          {props.optionPrice === '0.0'
            ? props.text
            : parseFloat(props.optionPrice).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
        </div>
      </div>
    );
  }

  return (
    <div className={`option-box-main ${selected}`}>
      <div className="option-box-text">{props.text}</div>
      <div className="option-box-variant-value">
        R$ {priceDifference >= 0 ? '+' : '-'} {formattedPriceDifference}
      </div>
    </div>
  );
};

export default OptionBox;
